import { Flex, Modal, Text } from "@wayflyer/flyui";
import React from "react";
import { useIntl } from "react-intl";

export const NotReadyModal = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const intl = useIntl();

  return (
    <Modal
      title={intl.formatMessage({
        id: "funding-application: outstanding steps title",
        defaultMessage: "You still have steps to complete",
      })}
      primaryAction={{
        onAction: () => setIsOpen(false),
        content: intl.formatMessage({ id: "funding-application: okay", defaultMessage: "Okay" }),
      }}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <Flex direction="column" gap="6">
        <Text>
          {intl.formatMessage({
            id: "funding-application: uncompleted steps warning message",
            defaultMessage:
              "It looks like you haven’t completed all steps listed on your application. You’ll need to complete these before continuing.",
          })}
        </Text>
        <Text>
          {intl.formatMessage({
            id: "funding-application: chat to us message",
            defaultMessage:
              "If you need help, chat to us using the link on this page or reach out to your Wayflyer representative directly.",
          })}
        </Text>
      </Flex>
    </Modal>
  );
};
